var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "ping" }, [
    _c("div", { staticClass: "ping-signal flex-align-center" }, [
      _c("p", { staticClass: "ping-signal-name text-min" }, [
        _vm._v(" " + _vm._s(_vm.$t("common.ping.nodeSignal")) + " "),
      ]),
      _c("div", { staticClass: "ping-signal-icon flex" }, [
        _c("div", { class: _vm.isSignalHave(5) }),
        _c("div", { class: _vm.isSignalHave(35) }),
        _c("div", { class: _vm.isSignalHave(65) }),
        _c("div", { class: _vm.isSignalHave(100) }),
        _c("div", { class: _vm.isSignalHave(500) }),
      ]),
      _c("p", { staticClass: "ping-data-text text-min" }, [
        _vm._v(_vm._s(_vm.dataVal) + "kb/s"),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }